<template>
  <div>
  </div>
</template>

<script>

export default {
  components: {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  computed: {
  },
};
</script>

<style scoped>
</style>
